import { CSSProperties, ReactNode } from 'react'
import styled from 'styled-components'

const Component = styled.div`
  &.danger {
    color: var(--color-danger);
  }

  &.error {
    color: var(--color-error);
  }

  &.success {
    color: var(--color-success);
  }
`

interface Props {
  variant: 'danger' | 'error' | 'info' | 'success' | 'warning'
  children: ReactNode
  style?: CSSProperties
}

const Message = ({ variant, children, style }: Props) => {
  return (
    <Component className={`message ${variant}`} style={style}>
      {children}
    </Component>
  )
}

Message.defaultProps = {
  variant: 'info',
}

export default Message
